/**
 * Phase 32 — how to get each channel's target, step by step, in the words of
 * the screens the person will see. Slack is set up once for the workspace:
 * one channel, a thread per country. Links open the exact page.
 * For Media Devoted | Created By Ciro Autiero
 */
export interface HowToStep {
  text: string;
  link?: { label: string; href: string };
}

export interface HowTo {
  question: string;
  steps: HowToStep[];
  /** A shorter road, when one exists. */
  alternative?: HowToStep[];
}

export const HOW_TO: Record<'TELEGRAM' | 'SLACK', HowTo> = {
  SLACK: {
    question: 'How do I get the webhook and the thread link?',
    steps: [
      { text: 'Every country uses one Slack channel. Each country is a thread you start inside that channel. The Allow screen only lets you pick the channel.' },
      { text: 'Open Slack’s app page and sign in:', link: { label: 'api.slack.com/apps', href: 'https://api.slack.com/apps' } },
      { text: 'Click "Create New App" → "From scratch". Name it "TrafficPulse", pick the workspace, then "Create App".' },
      { text: 'Incoming Webhooks → turn them on → "Add New Webhook to Workspace". On "Allow the TrafficPulse app to access Slack", "Channel for webhook" is the one alerts channel (for example #automation) → Allow. A thread cannot be chosen there.' },
      { text: 'Copy the Webhook URL (https://hooks.slack.com/services/…) into the Channel field, once — every country uses it from then on.' },
      { text: 'Open the SAME channel you picked for the webhook (#automation in the example) and post one message per country, named for the country (Australia, Denmark, …). That message is the thread — a message from any other channel is refused (invalid_thread_ts).' },
      { text: 'On the message, open the ⋯ menu and choose Copy link. Paste it into that country’s thread field (required to switch Slack on). Alerts reply under that message.' },
    ],
  },
  TELEGRAM: {
    question: 'How do I get the chat id?',
    steps: [
      { text: 'In Telegram, open the group or channel the alerts should go to.' },
      { text: 'Add the TrafficPulse bot to it as a member (ask the admin who set the bot up for its @name). In a channel, make the bot an admin so it can post.' },
      { text: 'Public channel: type its @name in the field above (e.g. @mychannel) — done.' },
      { text: 'Private group or channel: forward any message from it to the bot @getidsbot — it answers with the chat id (a long number, usually starting with -100). Paste that number in the field above.' },
    ],
    alternative: [
      { text: 'Or ask the admin who set the bot up: after someone posts in the group, the bot’s updates page shows "chat": { "id": -100… } — that number is the chat id.' },
    ],
  },
};
